import GeozonePalette from './GeozonePalette'

export default GeozonePalette